var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Mixins } from 'vue-property-decorator';
import TableProperties from './mixin/table-properties';
import SelectedRows from './mixin/selected-rows';
import { TableEvent } from '@core/plugin/tc/component/table/enums';
var TcTableSelectedRowsField = /** @class */ (function (_super) {
    __extends(TcTableSelectedRowsField, _super);
    function TcTableSelectedRowsField() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TcTableSelectedRowsField.prototype.mounted = function () {
        var _this = this;
        window.addEventListener(TableEvent.SelectedChanged, function (e) {
            if (e.detail.id == _this.id) {
                _this.selected = e.detail.selected;
            }
        });
    };
    TcTableSelectedRowsField = __decorate([
        Component({
            mixins: [TableProperties, SelectedRows],
        })
    ], TcTableSelectedRowsField);
    return TcTableSelectedRowsField;
}(Mixins(TableProperties, SelectedRows)));
export default TcTableSelectedRowsField;
